export const FETCH_REFUNDS_REQUEST = "FETCH_REFUNDS_REQUEST";
export const FETCH_REFUNDS_SUCCESS = "FETCH_REFUNDS_SUCCESS";
export const FETCH_REFUNDS_FAILURE = "FETCH_REFUNDS_FAILURE";

export const APPROVE_REFUND_REQUEST = "APPROVE_REFUND_REQUEST";
export const APPROVE_REFUND_SUCCESS = "APPROVE_REFUND_SUCCESS";
export const APPROVE_REFUND_FAILURE = "APPROVE_REFUND_FAILURE";

export const REJECT_REFUND_REQUEST = "REJECT_REFUND_REQUEST";
export const REJECT_REFUND_SUCCESS = "REJECT_REFUND_SUCCESS";
export const REJECT_REFUND_FAILURE = "REJECT_REFUND_FAILURE";

export const MARK_REFUND_REFUNDED_REQUEST = "MARK_REFUND_REFUNDED_REQUEST";
export const MARK_REFUND_REFUNDED_SUCCESS = "MARK_REFUND_REFUNDED_SUCCESS";
export const MARK_REFUND_REFUNDED_FAILURE = "MARK_REFUND_REFUNDED_FAILURE";
export const GENERATE_REFUND_FROM_FLAGGED_INVOICE_REQUEST = "GENERATE_REFUND_FROM_FLAGGED_INVOICE_REQUEST";
export const GENERATE_REFUND_FROM_FLAGGED_INVOICE_SUCCESS = "GENERATE_REFUND_FROM_FLAGGED_INVOICE_SUCCESS";
export const GENERATE_REFUND_FROM_FLAGGED_INVOICE_FAILURE = "GENERATE_REFUND_FROM_FLAGGED_INVOICE_FAILURE";